import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as transactionsActionTypes } from '../../actions/transactions';

export default makeCrudMetaReducer(transactionsActionTypes);
